module.exports = __webpack_public_path__ + "ffd1c32c0b9e7cd4da4045f3bc06683f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/picture/Canucks_0.jpg
// module id = 494
// module chunks = 0